import { Trans } from "@lingui/react/macro";
import { Box, Flex } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import CreateProduct from "@/features/products/create-product";
import ProductsTable from "@/features/products/products-table";
import { Can } from "@/shared/providers/casl-provider";

export const Route = createFileRoute("/_app/(multi-location)/admin/products/")({
  component: ProductsPage,
});

function ProductsPage() {
  return (
    <Box p="lg">
      <Flex align="center" justify="space-between">
        <h1>
          <Trans>Produkt</Trans>
        </h1>

        <Can I="create" a="Product">
          <CreateProduct />
        </Can>
      </Flex>

      <ProductsTable />
    </Box>
  );
}
